<footer id="page-footer" class="page-footer" [attr.role]="'contentinfo'">
    @if (footerItems$ | async; as footerItems) {
        <div class="main-footer">
            <div class="links-block">
                @if (footerItems.columns) {
                    <h-footer-columns-deprecated [columns]="footerItems.columns"></h-footer-columns-deprecated>
                }
            </div>

            <div class="here-to-help-block">
                <h-footer-here-to-help-deprecated></h-footer-here-to-help-deprecated>
            </div>

            @if (!isNewsletterRemove() || !isMobile()) {
                <div class="newsletter-subscribe-block">
                    <h-footer-newsletter-deprecated></h-footer-newsletter-deprecated>
                </div>
            }

            <div class="social-block">
                @if (footerItems.socialNetworks) {
                    <h-footer-social-networks-deprecated [socialNetworks]="footerItems.socialNetworks">
                    </h-footer-social-networks-deprecated>
                }
            </div>
        </div>

        <div class="sub-footer">
            <div class="country-selector-block">
                <h-footer-country-selector-button-deprecated></h-footer-country-selector-button-deprecated>
            </div>

            <h-svg-icon class="logo-block" [name]="'hermes-logo'"></h-svg-icon>

            @if (footerItems.legalLinks) {
                <div class="legal-links-block">
                    <h-footer-legal-links-deprecated [legalLinks]="footerItems.legalLinks">
                    </h-footer-legal-links-deprecated>
                </div>
            }
        </div>

        <div class="copyright-block">
            <h-footer-copyright-deprecated [hasLightCopyright]="false"></h-footer-copyright-deprecated>
        </div>
    }
</footer>
